import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/request.interceptor';
import { throttleInterceptor } from './interceptors/throttle.interceptor';
import { provideHighcharts } from 'highcharts-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding()
    ),
    provideHttpClient(
      // TEMPORARILY DISABLED: add `throttleInterceptor` back to re-enable the HTTP concurrency limiter
      withInterceptors([/* throttleInterceptor, */ authInterceptor]),
    ),
    provideHighcharts({
      instance: () => import('highcharts/modules/map').then(m => m.default || m),
      modules: () => [import('highcharts/modules/drilldown')],
    })
  ]
};
